angular.module('FlexyBeautyApp.controllers')
    .controller('BookingFormCtrl', ["$scope", "$timeout", "OfferManager", "StoreAppCode", "Images", "BookingCreator",
        function ($scope, $timeout, OfferManager, StoreAppCode, Images, BookingCreator) {
            $scope.bookingStatusImage = Images.saleStatus;
            $scope.startHourSel = false;
            $scope.startMinuteSel = false;
            $scope.datePicker = {
                opened: false,
                date: null
            };
            $scope.bookingDate = null; // edited booking date by date picker
            $scope.bookingView = null; // Direct access to bookingView Edited
            $scope.tailleTest = -1;
            $scope.serviceFilter = {
                text: null,
                timeOut: null,
                servicesView: null,
                customerServicesView: null
            };
            $scope.datePickerTimer = null;
            $scope.bookingCreator = BookingCreator;

            //Put in scope edited booking
            $scope.$watch('dd.view.pTView.edited.bookingView', function (bookingView) {
                if (bookingView && $scope.bookingView !== bookingView) {
                    $scope.displayServiceSelector = true;//display selector has period selected and bookingServices == 0
                    $scope.displayCustomerForm = false;
                    $scope.serviceFilter.text = null;
                    $scope.serviceFilter.servicesView = null;
                }
                $scope.bookingView = bookingView;
                if (bookingView && bookingView.plgDayView && bookingView.plgDayView.date) {
                    $scope.bookingDate = bookingView.plgDayView.date;
                }
                if ($scope.dd.view.pTView && $scope.dd.view.pTView.updateDisplaySelector) {
                    $scope.dd.view.pTView.updateDisplaySelector();
                }
            });

            $scope.onCustomerInputKeyDown = function (event) {
                let keyCode = event.which;
                //if key delete detected : clear customer
                if (keyCode == 8 || keyCode == 46) {
                    $scope.bookingView.removeCustomerView();

                }
            };
            $scope.setCurrentCategory = function (categoryView) {
                $scope.dd.view.cCategoryView = categoryView;
            };
            $scope.setCurrentProductCategory = function (categoryView) {
                $scope.dd.view.cProductCategoryView = categoryView;
            };
            $scope.displayDatePickerF = function () {
                if ($scope.datePickerTimer) {
                    $timeout.cancel($scope.datePickerTimer)
                }

                if (!$scope.bookingView.isReadOnly && $scope.bookingView.plgDayView)
                    $scope.datePickerTimer = $timeout(function () {
                        $scope.datePicker.date = new Date($scope.bookingView.plgDayView.date);
                        $scope.datePicker.opened = true;
                    });
            };

            $scope.onSearchServiceInputKeyDown = function () {

                if ($scope.dd.view.categoryRootView) {

                    if ($scope.serviceFilter.timeOut)
                        $timeout.cancel($scope.serviceFilter.timeOut);
                    $scope.serviceFilter.timeOut = $timeout(function () { //useTimeOut in order to search only when use finish typing (or barcode scanner stop)

                        if ($scope.serviceFilter.text && $scope.serviceFilter.text.length >= 2) {
                            let lowerText = $scope.serviceFilter.text.toLowerCase();
                            $scope.serviceFilter.customerServicesView = [];
                            $scope.serviceFilter.servicesView = $scope.dd.view.categoryRootView.getServicesViewByLabel(lowerText);
                            if ($scope.dd.view.pTView && $scope.dd.view.pTView.edited.bookingView && $scope.dd.view.pTView.edited.bookingView.customerView && $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices)
                                for (let i = 0; i < $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices.length; i++) {
                                    if ($scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView &&
                                        $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView.label &&
                                        $scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i].bsView.label.toLowerCase().indexOf(lowerText) !== -1)
                                        $scope.serviceFilter.customerServicesView.push($scope.dd.view.pTView.edited.bookingView.customerView.proposedServices[i]);
                                }
                        } else {
                            $scope.serviceFilter.servicesView = null;
                            $scope.serviceFilter.customerServicesView = null;
                        }
                    }, 250);


                }
            };
        }]);




// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/BookingFormCtrl.js